import React from 'react';
import { Button, Modal, Stack, spacing, useTheme } from '@fti/design-system';
import type { ImportError as ImportErrorType } from '../../types/dataset';

interface ImportErrorProps {
  error: ImportErrorType;
  onDismiss: () => void;
  onClearWorkspace?: () => void;
}

const ERROR_TITLES: Record<string, string> = {
  unsupported_format: 'Unsupported File Format',
  file_too_large: 'File Too Large',
  empty_file: 'Empty File',
  parse_failure: 'Parsing Error',
  encoding_error: 'Encoding Error',
  nesting_too_deep: 'Invalid JSON Structure',
};

export const ImportError: React.FC<ImportErrorProps> = ({ error, onDismiss, onClearWorkspace }) => {
  const { theme } = useTheme();

  const title = ERROR_TITLES[error.error_type] || 'Import Error';

  return (
    <Modal isOpen={true} onClose={onDismiss}>
      <Modal.Header onClose={onDismiss}>
        <h2 style={{ margin: 0, fontSize: '1.1rem', color: theme.colors.text.primary }}>
          {title}
        </h2>
      </Modal.Header>
      <Modal.Body>
        <Stack gap="md">
          <p
            style={{
              margin: 0,
              fontSize: '0.95rem',
              color: theme.colors.text.primary,
            }}
          >
            {error.message}
          </p>

          <div
            style={{
              padding: spacing.sm,
              borderRadius: '6px',
              backgroundColor: theme.colors.background.paper,
              fontSize: '0.85rem',
              color: theme.colors.text.secondary,
            }}
          >
            <strong>How to fix:</strong> {error.guidance}
          </div>
        </Stack>
      </Modal.Body>
      <Modal.Footer>
        {onClearWorkspace && (
          <Button variant="outline" color="primary" size="sm" onClick={onClearWorkspace}>
            Clear &amp; Retry
          </Button>
        )}
        <Button variant="solid" color="primary" size="sm" onClick={onDismiss}>
          Try again
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
